import React, {useEffect, useState} from 'react';
import {
    Container,
    Grid,
    Step,
    StepLabel,
    TableBody,
    TableRow, TextField,
    Typography,
} from '@mui/material';
import {
    Black, StyledButtonBlack,
    StyledButtonContainer, StyledButtonNoColor,
    StyledButtonOrange,
    StyledStepper,
    StyledTable, StyledTableCell,
} from '../../styles/MyStyles';
import {useNavigate, useParams} from "react-router-dom";
import * as DataProvider from "../../logic/DataProvider";
import {GetEnumValues} from "../../logic/EnumHelper";
import {GetClientViewName} from "../../logic/ClientNameHelper";
import {GetCookieInfo} from "../../logic/CookieManager";
import moment from "moment";
import {UpdateTicketStatus} from "../../logic/TicketHelper";
import {GetMessageFilesComponent} from "./TicketFilesHelper";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ClearIcon from '@mui/icons-material/Clear';


const ClientTicketPage = () => {
    const navigate = useNavigate();

    const { ticketId} = useParams();

    const [errors, setErrors] = useState({});

    const [clientDetails, setClientDetails] = useState();
    const [ticket, setTicket] = useState();
    const [activeStep, setActiveStep] = useState(0);

    const [newMessage, setNewMessage] = useState('');

    const [files, setFiles] = useState(null);
    const [filesToUpload, setFilesToUpload] = useState();


    useEffect(() => {
        fetchTicket();
        fetchFiles();
    }, [ticket]);

    const fetchTicket = () => {
        try {
            let bundle = DataProvider.GetClientBundle();
            setClientDetails(bundle.contact);
            if (bundle.tickets) {
                let entities = bundle.tickets;
                let entity = entities.find(e => e.id === Number(ticketId));

                entity.messages.sort((a, b) => {
                    const dateA = new Date(a.date);
                    const dateB = new Date(b.date);
                    return dateA - dateB;
                });

                setTicket(entity);
                setActiveStep(entity.status);
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const fetchFiles = async () => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TICKET_FILES_URL}/${ticketId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    }
                }
            );
            if (response.ok) {
                const data = await response.json();
                console.log('fetchFiles');
                console.log(data.data);
                setFiles(data.data);
            } else {
                console.log('Fetch ticket files failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const uploadFile = async (messageId) => {
        try {
            const tokenCookie = GetCookieInfo('nplt');

            const formData = new FormData();

            for (const file of filesToUpload) {
                formData.append('files', file);
            }

            formData.append("ticketId", ticketId);
            formData.append("messageId", messageId);

            const response = await fetch(
                `${process.env.REACT_APP_TICKET_FILES_URL}/upload`,
                {
                    method: 'POST',
                    headers: {
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: formData,
                }
            );
            if (response.ok) {
                console.log('File uploaded successfully.');
                await fetchFiles();

                setFilesToUpload(null);
            } else {
                console.log('File uploading failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const saveFile = (e) => {
        if (e.target.files.length > 0) {
            setFilesToUpload(e.target.files);
        } else {
            clearFiles();
        }
    };

    const clearFiles = () => {
        setFilesToUpload(null);
    };

    const validateForm = () => {
        let newErrors = {};

        if (!newMessage.trim()) {
            newErrors.newMessage = 'Message is required.';
        }

        return newErrors;
    };

    const handleBack = () => {
        navigate(-1);
    };

    const handleSendRequest = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            } else {
                setErrors({});
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TICKETING_URL}/message`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify({
                        ticketId: ticket.id,
                        message: newMessage
                    })
                }
            );
            if (response.ok) {
                const data = await response.json();
                ticket.messages.push(data.data.message);

                if (filesToUpload) {
                    await uploadFile(data.data.message.id);
                }

                let newStatus = data.data.newStatus;

                ticket.status = newStatus;
                setActiveStep(newStatus);

                setNewMessage('');
            } else {
                console.log('Message creating failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleCloseRequest = async () => {
        let statusChanged = await UpdateTicketStatus(ticket.id, 4);

        if (statusChanged) {
            ticket.status = 4;
            setActiveStep(4);
        } else {
            console.log('Cant change status to Solved.');
        }
    };

    const getAuthorName = (authorId) => {
        if (authorId === clientDetails.id) {
            return GetClientViewName(clientDetails);
        }
        return 'Support manager';
    };

    const handleFieldChange = (event) => {
        setNewMessage(event.target.value);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <StyledStepper activeStep={activeStep} alternativeLabel>
                {Object.values(GetEnumValues('ticketStatus')).map((label, index) => (
                    <Step key={index}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </StyledStepper>
            <StyledTable>
                <TableBody>
                    {ticket?.messages?.map((message) => (
                        <TableRow key={message.id}>
                            <StyledTableCell>
                                <Typography variant="h6" gutterBottom sx={{ color: Black }}>
                                     {getAuthorName(message.authorId)} {moment(message.date).fromNow()}
                                </Typography>
                                <Typography sx={{ mb: 1.5, whiteSpace: 'pre-line' }} color="text.secondary">
                                    {message.message}
                                </Typography>
                                {GetMessageFilesComponent(ticketId, message.id, files)}
                            </StyledTableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </StyledTable>
            {ticket && ticket?.status !== 4 && (
                <>
                    <TextField
                        name="newMessage"
                        label="New Message"
                        value={newMessage}
                        onChange={handleFieldChange}
                        fullWidth
                        multiline
                        rows={2}
                        required
                        error={!!errors.newMessage}
                        helperText={errors.newMessage}
                        style={{ padding: '5px' }}
                    />
                    <Grid container alignItems="center" style={{ padding: '5px'  }}>
                        <Grid item>
                            <input id='filePicker' multiple={true} type="file" onChange={saveFile} style={{ display: 'none' }}/>
                            <label htmlFor='filePicker'>
                                <Grid container alignItems="center">
                                    <StyledButtonNoColor variant="contained" component="span">
                                        <AttachFileIcon/>
                                    </StyledButtonNoColor>
                                    <Typography variant="body1" style={{ marginLeft: '8px' }}>
                                        {filesToUpload
                                            ? filesToUpload.length > 1 ? `Picked ${filesToUpload.length} files` :  filesToUpload[0].name
                                            : ''}
                                    </Typography>
                                </Grid>
                            </label>
                        </Grid>
                        <Grid item>
                            {filesToUpload && filesToUpload.length > 0 && (
                                <StyledButtonNoColor variant="contained" component="span" onClick={clearFiles} style={{ marginLeft: '8px' }}>
                                    <ClearIcon/>
                                </StyledButtonNoColor>
                            )}
                        </Grid>
                    </Grid>
                </>)}
            <StyledButtonContainer container>
                <Grid>
                    <StyledButtonOrange variant="contained" onClick={handleBack}>
                        Back
                    </StyledButtonOrange>
                </Grid>
                <Grid>
                    <StyledButtonOrange variant="contained" disabled={!ticket || ticket?.status === 4} color="primary" onClick={handleSendRequest}>
                        Send Comment
                    </StyledButtonOrange>
                </Grid>
                <Grid>
                    <StyledButtonBlack variant="contained" disabled={!ticket || ticket?.status === 4} color="primary" onClick={handleCloseRequest}>
                        Close ticket
                    </StyledButtonBlack>
                </Grid>
            </StyledButtonContainer>
        </Container>
    );
};

export default ClientTicketPage;
